import { ARTIFACT_DEFAULT_ICON } from "@/components/display/display-name/defaults";
import { useMatchRoute } from "@tanstack/react-router";
import { KitMenuTemplate } from "../KitMenuTemplate";
import { SETTINGS_GROUP_PARTIAL } from "./hooks";
import { KitTypeMenuProps } from "./types";

export const CollectionMenu: React.FC<KitTypeMenuProps> = ({
  mode,
  groupSlug,
  kit,
}) => {
  const matchRoute = useMatchRoute();
  const groups = [
    {
      title: "Artifacts",
      icon: ARTIFACT_DEFAULT_ICON,
      active: !!matchRoute({
        to: "/w/$groupSlug/k/$kitUuid/artifacts",
        params: { groupSlug, kitUuid: kit.uuid },
        fuzzy: true,
      }),
      link: {
        to: "/w/$groupSlug/k/$kitUuid/artifacts" as const,
        params: { groupSlug, kitUuid: kit.uuid },
      },
    },
    {
      ...SETTINGS_GROUP_PARTIAL,
      active: !!matchRoute({
        to: "/w/$groupSlug/k/$kitUuid/collection-settings",
        params: { groupSlug, kitUuid: kit.uuid },
        fuzzy: true,
      }),
      link: {
        to: "/w/$groupSlug/k/$kitUuid/collection-settings" as const,
        params: { groupSlug, kitUuid: kit.uuid },
      },
    },
  ];
  return <KitMenuTemplate kit={kit} groups={groups} mode={mode} />;
};
